import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/tablet/warehouse-receiving/incoming",
    })
  },
})
